import instance from "./instance";

const calibrationUrl = "/practice/v1/user/take-calibration";

export const getAllCalibrationSets = () => {
    return instance.get(
        `${calibrationUrl}/get-all-calibration-sets`
    );
}

export const skipCalibration = () => {
    return instance.get(
        `${calibrationUrl}/skip-calibration`
    );
}

export const submitCalibrationAnswer = (data) => {
    return instance.post(
        `${calibrationUrl}/submit-calibration-answers`,
        data
    );
}